import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_email = (id) => {
  return api.post(
    `${ApiEndpointConstants.DELETEEMALI}`,
    {},
    { params: { id } }
  );
};
